<template>
    <div class="library-deliverable-table-metadata-search-header-cell">
        <Input v-model="searchString" icon="ios-search" size="small" />
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";

const creativeLibraryFiltersStore = useCreativeLibraryFiltersStore();

const { fieldId } = defineProps<{
    fieldId: string;
}>();

const searchString = computed({
    get() {
        return creativeLibraryFiltersStore.metadataSearch[fieldId] || "";
    },
    set(newValue: string) {
        creativeLibraryFiltersStore.setMetadataSearch(fieldId, newValue);
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;
.library-deliverable-table-metadata-search-header-cell {
    width: 100%;
}
</style>
